//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseDisplayText', component.exports)
}
export default {
  name: "BaseDisplayText",
}
